import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=362b249e&"
import script from "./OtherInfo.vue?vue&type=script&lang=ts&"
export * from "./OtherInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports